"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiToLocation = void 0;
const tech_1 = require("../tech");
const projection_1 = require("./projection");
const apiToLocation = (st_x, st_y) => {
    return st_x && st_y ? (0, projection_1.convertInnerLocationToGPS)([(0, tech_1.apiToFloatNumber)(st_x), (0, tech_1.apiToFloatNumber)(st_y)]) : null;
};
exports.apiToLocation = apiToLocation;
